import EfImg from '@elem/ui/ef-img';
import { useProductStore } from '../../ProductProvider';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    const { pageType } = useProductStore();
    const BG_MAP: any = {
        [PAGE_TYPE.BASE]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726040393446/pc_ksp_08_base.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1726040393446/pc_ksp_08_base.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726040399629/m_ksp_08_base.jpg',
        },
        [PAGE_TYPE.MOTOR]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725594352743/pc_ksp_08.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1725594352743/pc_ksp_08.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725594664647/m_ksp_08.jpg',
        },
    };
    const bg = BG_MAP[pageType];

    return (
        <div className={styles.itemSelling}>
            <EfImg pc={bg.pc} pad={bg.pad} h5={bg.h5} />
            <div className="item-desc-h">
                <div className="item-line-1">{t('h_ms1')}</div>
            </div>
        </div>
    );
}
